import styled from 'styled-components';
import { LoadImage, Subtitle, Title } from 'components';

export const SOLUCOES_BANNER_HEIGHT = 1028;

export const Wrapper = styled.section<any>`
  overflow: hidden;
  position: relative;
  ${({ customStyle }) => customStyle}

  @media screen and (min-width: 998px) {
    height: 0;
    padding-bottom: ${(SOLUCOES_BANNER_HEIGHT / 1920) * 100}%;
  }

  @media screen and (max-width: 997px) {
  }
`;

export const BackgroundImage = styled(LoadImage)`
  position: absolute;

  @media screen and (min-width: 998px) {
    height: 100%;
    right: 0;
    top: 0;
  }

  @media screen and (max-width: 997px) {
    bottom: 275px;
    right: -278px;
    height: 555px;
  }
`;

export const OverlayImage = styled(LoadImage)<any>`
  position: absolute;
  z-index: 1;

  @media screen and (min-width: 998px) {
    opacity: 0;
    transform: translateX(10%);
    transition: opacity 1s ease-in-out, transform 1s ease-in-out;

    &.isVisible {
      opacity: 1;
      transform: translateX(0);
    }
  }

  ${({ styleProps: { imageStyle } }) => imageStyle}
`;

export const Grid = styled.div`
  align-content: flex-start;
  width: 100%;

  @media screen and (min-width: 998px) {
    height: 100%;
    left: 50%;
    position: absolute;
    top: 0;
    transform: translateX(-50%);
  }

  @media screen and (max-width: 997px) {
  }
`;

export const Content = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: 1441px) {
    grid-column: 2 / span 7;
  }

  @media screen and (max-width: 1440px) and (min-width: 998px) {
    grid-column: 1 / span 8;
  }

  @media screen and (min-width: 998px) {
  }

  @media screen and (max-width: 997px) {
    padding-top: 66px;

    ${Subtitle}, ${Title} {
      padding-left: 20px;
      z-index: 1;
    }

    ${Title} {
      font-size: 32px;
    }
  }
`;
